import $ from "jquery";

const StartingWorld = {
  elms: {
    startingWorld1: ".starting-world-1__Placeholder",
    startingWorld1Img: ".starting-world-1__frame",
    startingWorld2: ".starting-world-2__Placeholder",
    startingWorld2Img: ".starting-world-2__frame",
    startingWorld3: ".starting-world-3__Placeholder",
    startingWorld3Img: ".starting-world-3__frame",
    startingWorld4: ".starting-world-4__Placeholder",
    startingWorld4Img: ".starting-world-4__frame",
    startingWorld5: ".starting-world-5__Placeholder",
    startingWorld5Img: ".starting-world-5__frame",
    startingWorld6: ".starting-world-6__Placeholder",
    startingWorld6Img: ".starting-world-6__frame",
    startingWorld7: ".starting-world-7__Placeholder",
    startingWorld7Img: ".starting-world-7__frame",
  },

  resetCalculation: function () {
    [
      this.elms.startingWorld1Img,
      this.elms.startingWorld2Img,
      this.elms.startingWorld3Img,
      this.elms.startingWorld4Img,
      this.elms.startingWorld5Img,
      this.elms.startingWorld6Img,
      this.elms.startingWorld7Img,
    ].forEach((selector) => {
      $(selector).removeAttr("style");
    });
    $("body")[0].offsetWidth;
  },

  getBoundingBox: function (selector) {
    const elements = document.querySelectorAll(`svg path${selector}`);
    if (!elements.length) return null;

    return Array.from(elements).reduce(
      (acc, el) => {
        const bbox = el.getBoundingClientRect();
        return {
          maxWidth: Math.max(acc.maxWidth, bbox.width),
          maxHeight: Math.max(acc.maxHeight, bbox.height),
          minX: Math.min(acc.minX, bbox.left),
          minY: Math.min(acc.minY, bbox.top),
        };
      },
      { maxWidth: 0, maxHeight: 0, minX: Infinity, minY: Infinity }
    );
  },

  calculateCoverSize: function () {
    // Check if ANY starting world frame exists, not just the first one
    const hasAnyFrame = [
      this.elms.startingWorld1Img,
      this.elms.startingWorld2Img,
      this.elms.startingWorld3Img,
      this.elms.startingWorld4Img,
      this.elms.startingWorld5Img,
      this.elms.startingWorld6Img,
      this.elms.startingWorld7Img,
    ].some((selector) => $(selector).length > 0);

    if (!hasAnyFrame) return false;

    this.resetCalculation();

    const startingWorld1BBox = this.getBoundingBox(this.elms.startingWorld1);
    const startingWorld2BBox = this.getBoundingBox(this.elms.startingWorld2);
    const startingWorld3BBox = this.getBoundingBox(this.elms.startingWorld3);
    const startingWorld4BBox = this.getBoundingBox(this.elms.startingWorld4);
    const startingWorld5BBox = this.getBoundingBox(this.elms.startingWorld5);
    const startingWorld6BBox = this.getBoundingBox(this.elms.startingWorld6);
    const startingWorld7BBox = this.getBoundingBox(this.elms.startingWorld7);

    if (startingWorld1BBox) {
      $(this.elms.startingWorld1Img).css({
        width: startingWorld1BBox.maxWidth,
        height: startingWorld1BBox.maxHeight,
        left: startingWorld1BBox.minX,
        top: startingWorld1BBox.minY,
      });
    }
    if (startingWorld2BBox) {
      $(this.elms.startingWorld2Img).css({
        width: startingWorld2BBox.maxWidth,
        height: startingWorld2BBox.maxHeight,
        left: startingWorld2BBox.minX,
        top: startingWorld2BBox.minY,
      });
    }
    if (startingWorld3BBox) {
      $(this.elms.startingWorld3Img).css({
        width: startingWorld3BBox.maxWidth,
        height: startingWorld3BBox.maxHeight,
        left: startingWorld3BBox.minX,
        top: startingWorld3BBox.minY,
      });
    }
    if (startingWorld4BBox) {
      $(this.elms.startingWorld4Img).css({
        width: startingWorld4BBox.maxWidth,
        height: startingWorld4BBox.maxHeight,
        left: startingWorld4BBox.minX,
        top: startingWorld4BBox.minY,
      });
    }
    if (startingWorld5BBox) {
      $(this.elms.startingWorld5Img).css({
        width: startingWorld5BBox.maxWidth,
        height: startingWorld5BBox.maxHeight,
        left: startingWorld5BBox.minX,
        top: startingWorld5BBox.minY,
      });
    }
    if (startingWorld6BBox) {
      $(this.elms.startingWorld6Img).css({
        width: startingWorld6BBox.maxWidth,
        height: startingWorld6BBox.maxHeight,
        left: startingWorld6BBox.minX,
        top: startingWorld6BBox.minY,
      });
    }
    if (startingWorld7BBox) {
      $(this.elms.startingWorld7Img).css({
        width: startingWorld7BBox.maxWidth,
        height: startingWorld7BBox.maxHeight,
        left: startingWorld7BBox.minX,
        top: startingWorld7BBox.minY,
      });
    }
    return true;
  },
};

export default StartingWorld;
